function getQueryString(name) {
    //传进想要获取的querystring的key
    if (window.location.href.split("?").length < 2) {
        return "";
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let search = window.location.href.split("?")[1];
    var r = search.match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}
export default getQueryString;